import { Exclude, Expose, Type } from "class-transformer";
import { IsArray, IsDefined, IsInt } from "class-validator";

import { NumberRange } from "./NumberRange";

@Exclude()
export class SeasonDay {
  @IsInt()
  @IsDefined()
  @Expose()
  public day: number; // day in week (Date::getUTCDay)

  @IsArray()
  @IsDefined()
  @Expose()
  @Type(() => NumberRange)
  public hours: NumberRange[] = new Array<NumberRange>(); // (Date::getUTCHours)
}
